import { getOrderTiming } from './orderTiming';
import {
  normalizeDeliveryAddress,
  sameDeliveryDestination,
  DELIVERY_DETAIL_FIELDS,
  deliveryDetails,
} from './deliveryAddress';

export function destinationKey(value) {
  const address = normalizeDeliveryAddress(value);
  if (!address) return null;
  const text = (entry) =>
    String(entry ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  return JSON.stringify([
    ...['address', 'city', 'state', 'zipcode'].map((field) =>
      text(address[field])
    ),
    address.latitude,
    address.longitude,
    ...DELIVERY_DETAIL_FIELDS.map(
      (field) => deliveryDetails(address.addition)[field]
    ),
  ]);
}

// Revision also catches Delivery -> Takeout -> Delivery while a save is pending.
export default function checkoutContext(state) {
  return JSON.stringify([
    state.order?.contextRevision || 0,
    state.order?.type?.value,
    state.main?.user?.id,
    state.authorization?.checkoutSessionRevision || 0,
    state.restaurant?.selectedRestaurantId,
    getOrderTiming(state).key,
  ]);
}

// A write attempt additionally binds its destination and cart. Address editing
// uses the base context because selecting a new destination is its intended work.
export function checkoutAttemptContext(state, expectedAddress) {
  const selected = normalizeDeliveryAddress(state.address?.selectedAddress);
  // Anchor equivalence to the original destination, not the previous action:
  // successive small coordinate updates must not permit unbounded drift.
  const destination =
    expectedAddress &&
    selected &&
    sameDeliveryDestination(expectedAddress, selected)
      ? expectedAddress
      : selected;
  return JSON.stringify([
    checkoutContext(state),
    state.order?.type?.value === 'delivery'
      ? destinationKey(destination)
      : null,
    state.order?.type?.value === 'delivery'
      ? state.address?.intentRevision || 0
      : null,
    state.order?.cartItems,
    !!state.authorization?.isLoading,
    !!state.authorization?.sessionToken,
  ]);
}

export function createCheckoutAttemptContext(state) {
  // Keep the reducer's semantic anchor across ownership/coordinate publications,
  // not only within one request. Otherwise equivalent successive requests get
  // different serialized contexts and unnecessarily save/start checkout again.
  const expectedAddress = normalizeDeliveryAddress(
    state.address?.intentAnchor || state.address?.selectedAddress
  );
  return (current) => checkoutAttemptContext(current, expectedAddress);
}
